import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AdminAppShell } from '@/components/AdminAppShell';
import { requireRole } from '@/lib/auth';

export const Route = createFileRoute('/admin')({
  beforeLoad: ({ context, location }) => requireRole('Administrator', { context, location }),
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <AdminAppShell>
      <Outlet />
    </AdminAppShell>
  );
}
